import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import numberFormatter from '../../../common/numberFormatter';
import mathUtils from '../../../utils/mathUtils';
import CurrencyControl from '../../../app/components/CurrencyControl';

interface CashPaymentDetailsProps {
  total: number;
  paid: string;
  onPaidChange: (paid: string) => void;
}

export const CashPaymentDetails: React.FC<CashPaymentDetailsProps> = ({
  total,
  paid,
  onPaidChange,
}) => {
  const change = mathUtils.subtract(mathUtils.parse(paid || '0'), total);

  return (
    <div className="border rounded p-3 bg-light">
      <div className="row">
        <div className="col-md-6">
          <FormRow controlId="total" label="Razem do zapłaty">
            <Form.Control
              type="text"
              value={numberFormatter(total, true)}
              disabled
              className="bg-light"
            />
          </FormRow>
        </div>
        <div className="col-md-6">
          <FormRow controlId="paidAmount" label="Zapłacono">
            <CurrencyControl
              value={paid}
              decimalScale={2}
              onChange={e => onPaidChange(e ? e.toString() : '')}
            />
          </FormRow>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-6 offset-md-6">
          <FormRow controlId="change" label="Reszta">
            <Form.Control
              type="text"
              value={numberFormatter(change, true)}
              disabled
              className={`bg-light ${change < 0 ? 'border-danger' : ''}`}
            />
          </FormRow>
        </div>
      </div>
    </div>
  );
};
